import React, { useCallback, useEffect } from 'react'
import Dashh from './dashh'
import { useNavigate } from 'react-router';
import RevampBanner from '../components/RevampBanner'

const InvestorDashboard = () => {
    const navigate = useNavigate()
    const finvolveInvestorData = JSON.parse(localStorage.getItem("finvolveInvestorData"));

    const checkIfUserIsLoggedIn = useCallback(async()=>{
        const finvolveInvestorData = JSON.parse(localStorage.getItem("finvolveInvestorData"))
        if(!finvolveInvestorData?.email){
            navigate("/investor-login")
            return
        }
    },[navigate])

    useEffect(()=>{
      checkIfUserIsLoggedIn();
    },[checkIfUserIsLoggedIn])

    if(!finvolveInvestorData?.email){
        return
    }

  return (
    <div>
        <RevampBanner part="description" sx={{ borderRadius: 0 }}/>
        <Dashh/>
    </div>
  )
}

export default InvestorDashboard